import logo from "../../assets/images/logo2.png";
import "./signInstyle.css";

function MaintenanceView() {
    return (
        <div className="main-block">
            <div className="container">
                <div className="login-block-txt">
                    <div className="login-box">
                        <img src={logo} className="my-5" alt="" />
                        <h3 className="headding-title-login my-4">
 DX Enablement Hub is temporarily unavailable.</h3><h3>Adobe Learning Manager (ALM), the platform powering DX Enablement Hub, is undergoing a scheduled system upgrade from <b>August 15, 11:30 PM EDT</b> through <b>August 16, 8:30 AM EDT</b>.</h3><h3>During this window, course access and learning features will be unavailable. Well be back online once the upgrade is complete.</h3><h3 className="headding-title-login my-4">For any questions or concerns please contact <a href="mailto:satija@adobe.com">Himanshu Satija</a> or <a href="mailto:dx-sio-enablement@adobe.com">dx-sio-enablement@adobe.com</a></h3>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default MaintenanceView;
